module.exports = __webpack_public_path__ + "img/hr-tree-06-d-leaves.9d58df15.png";